interface AdsAdminFormLike {
    getRoot(): HTMLElement;
    getListEl(): HTMLElement | null;
    getAddOpenButton(): HTMLButtonElement | null;
    getCreateForm(): HTMLFormElement | null;
    getCreateCloseButtons(): HTMLElement[];
}

interface AdsAdminHandlerLike {
    handleListClick(event: MouseEvent): void;
    handleListChange(event: Event): void;
    submitRow(event: SubmitEvent): Promise<void>;
    openCreateModal(): void;
    closeCreateModal(): void;
    submitCreateForm(event: SubmitEvent): Promise<void>;
}

export class AdsAdminListener {
    public form: AdsAdminFormLike;

    public handler: AdsAdminHandlerLike;

    public constructor(form: AdsAdminFormLike, handler: AdsAdminHandlerLike) {
        this.form = form;
        this.handler = handler;
    }

    public register(): void {
        const root = this.form.getRoot();
        if (root.dataset.adsAdminBound === "1") {
            return;
        }

        root.dataset.adsAdminBound = "1";

        const listEl = this.form.getListEl();
        if (listEl instanceof HTMLElement) {
            listEl.addEventListener("click", (event) => this.handler.handleListClick(event));
            listEl.addEventListener("change", (event) => this.handler.handleListChange(event));
            listEl.addEventListener("submit", (event) => {
                void this.handler.submitRow(event as SubmitEvent);
            });
        }

        const addOpenButton = this.form.getAddOpenButton();
        addOpenButton?.addEventListener("click", (event) => {
            event.preventDefault();
            this.handler.openCreateModal();
        });

        for (const closeButton of this.form.getCreateCloseButtons()) {
            closeButton.addEventListener("click", (event) => {
                event.preventDefault();
                this.handler.closeCreateModal();
            });
        }

        const createForm = this.form.getCreateForm();
        createForm?.addEventListener("submit", (event) => {
            void this.handler.submitCreateForm(event as SubmitEvent);
        });
    }
}
